import React from 'react';
import {
  arrayOf, bool, func, instanceOf, number, oneOf, shape, string
} from 'prop-types';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
// import { utils } from '@thd-olt-component-react/elements';
import Content from '../Content/Content.component';
import { EtchPlaceholder } from '../Placeholder/EtchPlaceholder';

const getEtchContent = ({
  dpdNewTab,
  env,
  templates,
  linkType,
  ...rest
}) => templates.reduce((acc, template, templateIndex) => [
  ...acc,
  ...template.content.map((content, contentIndex) => (
    <Content
      // host={utils.getHost({ env })}
      key={`etch--${templateIndex}-${content.id}-${contentIndex}`}
      opts={content}
      linkType={linkType}
      dpdNewTab={dpdNewTab}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  ))
], []);

const Etch = ({
  apiKey,
  dpdNewTab,
  env,
  preview,
  templatePath,
  templates = [],
  linkType,
  ...rest
}) => {

  // Need to have templates or template path to render
  if (!(templates.length)) {
    return null;
  }
  // const goToAnchor = () => {
  //   if (typeof window !== 'undefined') {
  //     const { hash } = window && window.location;
  //     if (hash !== '') {
  //       setTimeout(() => {
  //         const id = hash.replace('#', '');
  //         const element = document.getElementById(id);
  //         if (element) {
  //           element.scrollIntoView(true);
  //           if (rest.channel === 'mobile') {
  //             // Need to reduce fixed header height for mobile
  //             const offsetHeight = 50;
  //             const { scrollY } = window;
  //             if (scrollY) {
  //               window.scroll(0, scrollY - offsetHeight);
  //             }
  //           }
  //         }
  //       }, 1000);
  //     }
  //   }
  // };
  const content = getEtchContent({
    ...rest,
    dpdNewTab,
    env,
    templates,
    linkType
  });
  return (
    <LoadingPlaceholder
      customPlaceholder={EtchPlaceholder()}
      ready
    >
      {content}
    </LoadingPlaceholder>
  );
};

Etch.propTypes = {
  apiKey: string,
  channel: oneOf([
    'desktop',
    'mobile'
  ]),
  contentType: string,
  dimensions: instanceOf(Array),
  dpdNewTab: bool,
  env: oneOf([
    'dev',
    'stage',
    'prod-beta',
    'prod'
  ]),
  /** Exclude content of these types */
  exclude: arrayOf(string),
  favorites: arrayOf(number),
  /** Include only content of these types */
  include: arrayOf(string),
  isCategory: bool,
  linkType: string,
  onFavoriteChange: func,
  onVisNavRender: func,
  parentNavParam: string,
  partialTemplates: instanceOf(Array),
  preview: bool,
  sku: instanceOf(Array),
  storeId: string,
  /** Path to etch json file */
  templatePath: string,
  /** Array of etch content definitions */
  templates: instanceOf(Array),
  visualNavPromos: arrayOf(shape([{
    sortIndex: string,
    name: string,
    startDate: string,
    endDate: string,
    visNavBanner: {
      position: string,
      'n-Value': string,
      linkText: string,
      imageUrl: string
    }
  }]))
};

Etch.defaultProps = {
  apiKey: null,
  channel: 'desktop',
  contentType: 'categorypage',
  dimensions: [],
  dpdNewTab: false,
  env: 'prod',
  exclude: [],
  favorites: [],
  include: [],
  isCategory: true,
  linkType: null,
  onFavoriteChange: null,
  onVisNavRender: () => {},
  parentNavParam: '',
  partialTemplates: [],
  preview: false,
  sku: [],
  storeId: '121',
  templatePath: null,
  templates: [],
  visualNavPromos: []
};

export default Etch;
